export enum ExportFileTypeEnum {
  HTML = "HTML",
  PDF = "PDF",
  EXCEL = "EXCEL",
  URL = "URL"
}
